import appAxios from '../../utils/appAxios.js';
export default {
    namespaced: true,

    state: {
        user: {
            id: 0,
            firstName: null,
            lastName: null,
            email: null,
            password: null,
            confirmPassword: null,
            phone: null,
            countryId: 0,
            cityId: 0,
            districtId: 0,
            streetAddress: null,
            userRoleId: null,
            defaultLanguageId: 0,
            active: true,
        },
        userList: [],
        totalRecords: 0,
        loading: false,
        timeZones: [],
    },
    getters: {
        _getUser: (state) => { return state.userList },
        _getTotalRecords: (state) => { return state.totalRecords },
        _getLoading: (state) => { return state.loading },
        _getTimeZones: (state) => { return state.timeZones }
    },
    mutations: {
        SET_USER_LIST(state, Data) {
            state.userList = []
            state.totalRecords = Data.TotalItemsCount
            if (Data.ListItems.length > 0) {
                Data.ListItems.forEach(item => {
                    state.userList.push(item)
                });
            }
            state.loading = false
        },
        SET_TIME_ZONES(state, Data) {
            state.timeZones = Data
        }
    },
    actions: {

        async GET_USER_PROJECTS(_, payload) {
            return new Promise(resolve => {
                appAxios.post("/admin/User/GetUserProjects", payload).then(response => {

                    if (response.data.Success) {
                        resolve(response.data.Data)
                    }
                    else { resolve([]) }
                })

            })

        },

        async GET_USER_ACTIVITIES(_, payload) {
            return new Promise(resolve => {
                appAxios.post("/admin/User/GetUserActivities", payload).then(response => {

                    if (response.data.Success) {
                        resolve(response.data.Data)
                    }
                    else { resolve([]) }
                })

            })

        },

        async GET_USER_AUDITS(_, payload) {
            return new Promise(resolve => {
                appAxios.post("/admin/User/GetUserAudits", payload).then(response => {

                    if (response.data.Success) {
                        resolve(response.data.Data)
                    }
                    else { resolve([]) }
                })

            })

        },


        async CHANGE_ACTIVE(_, payload) {
            return new Promise(resolve => {
                appAxios.post("/admin/User/UpdateActive", payload).then((response) =>
                    resolve(response.data.Success)
                )
            })
        },

        async CHANGE_PASSWORD(_, payload) {
            return new Promise((resolve => {
                appAxios.post('/admin/User/ChangePassword', payload).then(response => {
                    resolve(response.data.Success)
                })
            }))

        },

        async CHANGE_PUBLIC_PASSWORD(_, payload) {
            return new Promise((resolve => {
                appAxios.post('/User/ChangePassword', payload).then(response => {
                    resolve(response.data)
                })
            }))

        },

        async GET_COMMONN_USERROLE() {
            return new Promise((resolve) => {
                appAxios.get("/Common/GetUserGroups").then(response => {
                    if (response.data.Success) {
                        resolve(response.data.Data)
                    }
                    else {
                        resolve([])
                    }
                })
            })

        },

        async GET_COMMONN_USERS() {
            return new Promise((resolve) => {
                appAxios.get("/common/getUsers").then(response => {
                    if (response.data.Success) {
                        resolve(response.data.Data)
                    }
                    else {
                        resolve([])
                    }
                })
            })

        },

        async GET_USER(_, payload) {
            return new Promise(resolve => {
                appAxios.get(`/admin/user/get/${payload}`).then(response => {
                    if (response.data.Success) {
                        resolve(response.data.Data)
                    }
                    else {
                        resolve(null)
                    }
                })
            })
        },

        async GET_ALL_USERS({ commit, state }, payload) {
            state.loading = true
            await appAxios.post("/admin/User/GetAll", payload).then(response => {
                if (response.data.Success) {
                    commit("SET_USER_LIST", response.data.Data)
                }
            }).catch(() => state.loading = false)
        },

        async ADD_USER(_, payload) {
            let value = {}
            Object.keys(payload).forEach(i => {
                if (i === 'groups') {
                    value[i] = payload.groups.map(Number)
                } else {
                    value[i] = payload[i]
                }
            }
            )
            return new Promise(resolve => {
                appAxios.post("/admin/user/create", value).then(response => {
                    resolve(response.data.Success)
                })
            })
        },
        async ADD_CUSTOMER_USER(context, payload) {
            return new Promise(resolve => {
                appAxios.post("/admin/user/create", payload).then(response => {
                    resolve(response.data.Success)
                })
            })
        },

        async UPDATE_USER(_, payload) {
            let value = {}
            Object.keys(payload).forEach(i => {
                if (i === 'groups') {
                    value[i] = payload.groups.map(Number)
                } else {
                    value[i] = payload[i]
                }
            }
            )

            return new Promise(resolve => {
                appAxios.post("/admin/user/update", value).then(response => {
                    resolve(response.data.Success)
                })
            })

        },

        async UPDATE_CUSTOMER_USER(context, payload) {
            return new Promise(resolve => {
                appAxios.post("/admin/user/update", payload).then(response => {
                    resolve(response.data.Success)
                })
            })
        },

        async UPDATE_PUBLIC_USER(_, payload) {
            return new Promise(resolve => {
                appAxios.post("/user/update", payload).then(response => {
                    resolve(response.data.Success)
                })
            })

        },

        async DELETE_USER({ dispatch }, payload) {
            return new Promise(resolve => {
                appAxios.post("/admin/user/delete", payload).then(response => {
                    resolve(response.data.Success)
                })
            })

        },

        async UPDATE_USER_LANGUAGE(payload) {
            return new Promise(resolve => {
                appAxios.get(`/User/UpdateLanguageId?languageId=${payload}`).then(response => {
                    resolve(response.data.Success)
                })
            })
        },

        async GET_TIME_ZONES({ commit }) {
            await appAxios.get('/Common/GetTimeZones').then(response => {
                if (response.data.Success) {
                    commit("SET_TIME_ZONES", response.data.Data)
                } else { commit("SET_TIME_ZONES", []) }
            }).catch(() => { commit("SET_TIME_ZONES", []) })
        },
        async SET_PROFILE_IMAGE(_, payload) {
            return new Promise(resolve => {
                let responseStatus = false
                appAxios.post("/admin/User/UploadProfilePicture", payload).then(response => {
                    responseStatus = response.data.Success
                }).catch(() => responseStatus = false).finally(() => resolve(responseStatus))

            })

        },
        async DELETE_PROFILE_IMAGE(_, payload) {
            return new Promise(resolve => {
                let responseStatus = false
                appAxios.get(`/admin/User/DeleteProfilePicture?userId=${payload}`).then(response => {
                    responseStatus = response.data.Success
                }).catch(() => responseStatus = false).finally(() => resolve(responseStatus))
            })
        },
        async COMMON_AUDITOR_USERS() {
            return new Promise((resolve) => {
                appAxios.get("/Common/GetAuditorUsers").then(response => {
                    if (response.data.Success) {
                        resolve(response.data.Data)
                    }
                    else {
                        resolve(false)
                    }
                })

            })
        }

    }

}